import {
  LegacyQRCodeShipment as LegacyQRCodeShipmentDto,
  QRCodeShipmentStatusEnum,
} from '@electricjs/core_entity-client';

import { mockMac } from '@/mocks/data/assetData';
import { mockOrganizationId } from '@/mocks/data/siteData';

export const mockInitialShipments: LegacyQRCodeShipmentDto[] = [
  {
    id: 'a5a5a5a5-0000-4000-8000-000000000001',
    organization_id: mockOrganizationId,
    status: QRCodeShipmentStatusEnum.InTransit,
    ups_tracking_number: '1Z999AA10123456784',
    asset_id: mockMac.id,
    device_name: mockMac.name,
    device_serial_number: mockMac.serialNumber,
    shipper_employee_name: 'Tom McGurl',
    shipper_employee_email: 'tom.mcgurl@example.com',
    administrator_update_email: 'it-admin@example.com',
    ship_from_address_string: '123 Main St, New York, NY 10001, US',
    ship_from_address: {
      street_1: '123 Main St',
      city: 'New York',
      state: 'NY',
      zip_code: '10001',
      country: 'US',
    },
    ship_to_address_string: '500 Warehouse Way, Newark, NJ 07102, US',
    ship_to_address: {
      street_1: '500 Warehouse Way',
      city: 'Newark',
      state: 'NJ',
      zip_code: '07102',
      country: 'US',
    },
    ship_to_electric_warehouse: true,
    created_at: '2024-09-10T12:00:00.000000+00:00',
    updated_at: '2024-09-11T12:00:00.000000+00:00',
    expires_at: '2024-10-10T12:00:00.000000+00:00',
  },
];
